import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../../tools/tools";

const ProfileInfo = ({ sppurchaseid = null }) => {
	const { queryMSISDNVICCIDBySPPurchaseId, querySPPurchaseBySPPurchaseId } = useDealer();
	const [simcard, setSimcard] = useState({});
	const [purchase, setPurchase] = useState({});
	useEffect(() => {
		const initial = async () => {
			const response = await queryMSISDNVICCIDBySPPurchaseId(sppurchaseid);
			if (response) {
				setSimcard(response);
			}
			const purchase = await querySPPurchaseBySPPurchaseId(sppurchaseid);
			if (purchase) {
				setPurchase(purchase);
			}
		};
		initial();
	}, []);
	return (
		<>
			<div className="purchase_detail_360">
				<div className="page_title">اطلاعات سفارش</div>
				<div className="page_body">
					<Row>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">درگاه خرید:</div>
							<div className="value">{purchase?.bankName}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">تاریخ خرید:</div>
							<div className="value">{convertToJalaliWithTime(purchase?.dtE_PurchaseDate)}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">نام بسته اولیه(آغازین):</div>
							<div className="value">{purchase?.packagename}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">کانال فروش:</div>
							<div className="value">{purchase?.stR_PlanName}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">وضعیت خرید:</div>
							<div className="value">{purchase?.stR_PurchaseState}</div>
						</Col>
					</Row>
					<Row>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">روش دریافت:</div>
							<div className="value">{purchase?.stR_MethodOfReceiptType}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">شاهکار:</div>
							<div className="value">{purchase?.shahkarId ? "دارد" : "ندارد"}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">نام کاربر:</div>
							<div className="value">{purchase?.userName || "-"}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">مبلغ پرداختی:</div>
							<div className="value">{complexDigitToman(purchase?.inT_PurchaseAmount)}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">کد تخفیف:</div>
							<div className="value">{purchase?.discountcode || "-"}</div>
						</Col>
					</Row>
					<Row>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">درصد تخفیف:</div>
							<div className="value">{purchase?.discountPercent || "0"}</div>
						</Col>
					</Row>
				</div>

				<div className="page_title">اطلاعات سیم کارت</div>
				<div className="page_body">
					<Row>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">شماره کیت:</div>
							<div className="value" dir="ltr">
								{simcard?.stR_ICCID?.slice(10, 19)}
							</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">تاریخ خرید:</div>
							<div className="value" dir="ltr">{`${convertToJalaliWithTime(simcard?.dteOperationDate) || "-"} - ${
								formatTime(simcard?.dteOperationDate) || ""
							}`}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">نوع سیم کارت:</div>
							<div className="value">{simcard?.stR_MSISDNSimcardType}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">PIN 1:</div>
							<div className="value">{simcard?.stR_PIN1}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">PIN 2:</div>
							<div className="value">{simcard?.stR_PIN2}</div>
						</Col>
					</Row>
					<Row>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">PUK 1:</div>
							<div className="value">{simcard?.stR_PUK1}</div>
						</Col>
						<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
							<div className="label">PUK 2:</div>
							<div className="value">{simcard?.stR_PUK2}</div>
						</Col>
					</Row>
				</div>
			</div>
		</>
	);
};

export default ProfileInfo;
